import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import InputField from '../../components/InputField';
import PageLayout from '../../components/PageLayout';
import { REFERRAL_CODE_GIVEN, REFERRAL_CODE_NOT_GIVEN } from '../../constants/heapEvents';
import analytics from '../../lib/analytics';
import { track } from '../../lib/heapHelpers';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { customerGuidSelector } from '../../reducers/selectors';
import './index.scss';

const LOAN_APPLICATION_HEADERS = [
  {
    title: 'Eligibility',
  },
  {
    title: 'Personal Details',
  },
  {
    title: 'Personal Finances',
  },
  {
    title: 'Previous Education',
  },
  {
    title: 'Employment',
  },
  {
    title: 'Loan Details',
  },
  {
    title: 'Provisional Offer',
  },
];

const ReferralCodePage = ({
  initialReferralCode,
  dispatchAddPageData,
  dispatchWizardNav,
  customerGuid,
}) => {
  const [referralCode, setReferralCode] = useState(initialReferralCode);
  const isInvalid = () =>
    referralCode?.length !== 0 && referralCode?.length !== 8 && referralCode?.length !== 10;

  const handleReferralCodeChange = event => {
    event.preventDefault();
    setReferralCode(event.target.value);
  };

  const onWithoutCode = event => {
    event.preventDefault();
    track(REFERRAL_CODE_NOT_GIVEN, {
      'Customer GUID': customerGuid,
    });

    analytics.sendEvent(REFERRAL_CODE_NOT_GIVEN, 'referral-code');

    dispatchAddPageData(payloadFactory.createAddPageDataPayload('referralCode', ''));
    dispatchResetReferralCode();
    dispatchWizardNav({ dir: 'fwd' });
  };

  const handleSubmit = event => {
    event.preventDefault();

    if (isInvalid()) {
      return;
    }

    if (referralCode.length === 0) {
      onWithoutCode(event);
      return;
    }

    track(REFERRAL_CODE_GIVEN, {
      'Customer GUID': customerGuid,
    });

    analytics.sendEvent(REFERRAL_CODE_GIVEN, 'referral-code');

    const payload = payloadFactory.createAddPageDataPayload('referralCode', referralCode);
    dispatchAddPageData(payload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  const dispatchResetReferralCode = () => {
    dispatchAddPageData(payloadFactory.createAddPageDataPayload('ReferralCode', ''));
  };

  const helpText = 'It takes about 10 minutes to complete the application.';

  return (
    <PageLayout title="Get a provisional offer" helpText={helpText}>
      {/* Headers */}
      <div className="flex flex-col gap-6 py-4 -mt-1">
        {LOAN_APPLICATION_HEADERS.map((header, index) => (
          <div className="flex justify-between items-center py-1" key={index}>
            <span className="desktop-d-section-header">
              {index + 1}. {header.title}
            </span>
          </div>
        ))}
      </div>
      <form className="referral-form flex flex-col mt-8 gap-12 " onSubmit={handleSubmit}>
        <div className="-mt-4 -mb-1">
          <label className="text-xs" htmlFor="referral-code">
            Referral code (optional)
          </label>
          <InputField
            id="referral-code"
            type="text"
            value={referralCode}
            onChange={handleReferralCodeChange}
          />
        </div>

        <div className="-mt-1">
          <Button type="submit" isDisabled={isInvalid()} className="niso-button">
            Start
          </Button>
        </div>
      </form>
    </PageLayout>
  );
};

ReferralCodePage.propTypes = {
  initialReferralCode: PropTypes.string.isRequired,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
  customerGuid: PropTypes.string.isRequired,
};

const mapStateToProps = reduxStore => ({
  initialReferralCode: reduxStore.builder.ui.referralCode,
  customerGuid: customerGuidSelector(reduxStore),
});

const mapDispatchToProps = dispatch => ({
  dispatchAddPageData: data => dispatch(addPageData(data)),
  dispatchWizardNav: nav => dispatch(navigateWizard(nav)),
});

export { ReferralCodePage, mapStateToProps, mapDispatchToProps };

export default connect(mapStateToProps, mapDispatchToProps)(ReferralCodePage);
